import React from "react";

const AlertsSkeletonLoader: React.FC = () => {
  return (
    <div className="h-full overflow-auto bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="max-w-6xl mx-auto px-6 pt-16 pb-8 min-h-full">
        <div className="mt-2">
          {/* Create Alert Button skeleton */}
          <div className="bg-white rounded-2xl border border-gray-200 p-6 mb-4 flex items-center justify-center">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-gray-200 rounded-xl animate-pulse"></div>
              <div className="h-6 bg-gray-200 rounded w-32 animate-pulse"></div>
            </div>
          </div>

          {/* Alerts Header skeleton */}
          <div className="mb-4 flex items-center justify-between">
            <div className="h-6 bg-gray-200 rounded w-16 animate-pulse"></div>
            <div className="h-10 bg-gray-200 rounded w-48 animate-pulse"></div>
          </div>

          {/* Alerts Grid skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-8">
            {/* Alert Cards skeleton */}
            {[...Array(6)].map((_, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl border border-gray-200 p-6 h-32 flex flex-col relative"
              >
                {/* Status Badge skeleton - Top Right */}
                <div className="absolute top-3 right-3 h-6 bg-gray-200 rounded w-16 animate-pulse"></div>

                <div className="flex flex-col items-center text-center flex-1">
                  <div className="w-10 h-10 bg-gray-200 rounded-xl mb-3 animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded w-24 animate-pulse mb-1"></div>
                  <div className="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertsSkeletonLoader;
